import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';

import { Card } from '@/components/ui/card';

import { SettingsPageWrapper } from '../../components/settings-page-wrapper';
import { TimeOffTypesTable } from '../../components/time-offs/time-off-types-table';
import { useTimeOffTypes } from '../../hooks/time-offs/use-time-off-types';
import { SettingsOutletContext } from '../../types/settings-footer';

export const TimeOffSettingsPage = () => {
  const { t } = useTranslation('authenticated.settings');
  const { data, isLoading, error, refetch } = useTimeOffTypes();
  const { setContentMaxWidth } = useOutletContext<SettingsOutletContext>();

  useEffect(() => {
    setContentMaxWidth('max-w-5xl');
    return () => setContentMaxWidth(undefined);
  }, [setContentMaxWidth]);

  return (
    <SettingsPageWrapper isLoading={false} error={null}>
      <Card className="p-6">
        <div className="mb-4">
          <h2 className="text-lg font-semibold leading-7">{t('pages.timeOff.title')}</h2>
        </div>
        <p className="mb-4 text-xs text-muted-foreground">{t('pages.timeOff.description')}</p>
        <TimeOffTypesTable
          data={data ?? []}
          isLoading={isLoading}
          error={error}
          onRetry={() => void refetch()}
        />
      </Card>
    </SettingsPageWrapper>
  );
};
